import { useQuery } from '@tanstack/vue-query';
import axios from 'axios';

export function useEmployeesInPayrollData(payrollId: number) {
    const { data: employees, isPending: isLoadingEmployees } = useQuery({
        queryKey: ['employees-in-payroll', payrollId],
        queryFn: async () => {
            const { data } = await axios.get(
                route('v2.salary.payrolls.employees.in-payroll', { payroll: payrollId }),
            );
            return data;
        },
        placeholderData: [],
    });

    return {
        employees,
        isLoadingEmployees,
    };
}
